import { pathOr } from './utils/utils';

/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
type FindInDataFn = <T extends Record<string, any>>(data: T) => (str: string) => any;
const findInData: FindInDataFn = (data) => (str) => pathOr(`<% ${str} %>`, str.split('.'), data);

/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
type parseTokenFn = <T extends Record<string, any>>(data: T) => (str: string) => string;
const parseToken: parseTokenFn = (data) => (str) =>
	str
		.slice(2, -2)
		.split(' ')
		.filter((item) => item)
		.map(findInData(data))
		.join(' ')
		.trim();

export const smplTmplt = <T extends Record<string, unknown>>(template: string, data: T): string =>
	template.replace(/<%\s?[a-zA-Z0-9\n_.-]{1,256}\s?%>/g, parseToken(data));
